<template lang="html">
  <div>
    <p
      class="app-version-tag is-padded-small"
      :class="[{ 'badge-tag': badge }]"
    >
      App Version {{ appVersion }}
    </p>
    <span v-if="isDevelopment" class="dev-badge">Development</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'cw-app-version',
  props: {
    badge: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState({
      appVersion: state => state.header.appVersion,
    }),
    isDevelopment() {
      return process.env.NODE_ENV === 'development';
    },
  },
};
</script>

<style lang="stylus" scoped>

.app-version-tag {
  padding: 0.5em
  display: inline
  color: #aaaaaa
}

.badge-tag {
  border-radius: 4px
  background: #00000025
  color: #666666
}

.dev-badge {
  display: inline-block
  background: #e53e3e
  color: #ffffff
  font-size: 0.7em
  font-weight: bold
  padding: 2px 6px
  border-radius: 4px
}
</style>
